import React from 'react';
import { Capitalize } from '../../utils/text/Capitalize';

type KnownCategory =
  | 'Laptops'
  | 'Laptop'
  | 'Computers'
  | 'Desktops'
  | 'Desktop'
  | 'Smartphone'
  | 'Firewall'
  | 'Poe Switch'
  | 'Switch'
  | 'Network Equipment'
  | 'Werkstation';

type CategoryStyle = {
  background: string;
  color: string;
};

const knownCategoryStyles: Record<KnownCategory, CategoryStyle> = {
  Laptops: { background: '#EAF3FC', color: '#1A5276' },
  Laptop: { background: '#EAF3FC', color: '#1A5276' },
  Computers: { background: '#E9F7EF', color: '#196F3D' },
  Desktops: { background: '#FEF9E7', color: '#7E5109' },
  Desktop: { background: '#FEF9E7', color: '#7E5109' },
  Werkstation: { background: '#FEF9E7', color: '#7E5109' },
  Smartphone: { background: '#E0F7FA', color: '#006064' },
  Firewall: { background: '#FDEDEC', color: '#922B21' },
  'Poe Switch': { background: '#FDEDEC', color: '#922B21' },
  Switch: { background: '#FDEDEC', color: '#922B21' },
  'Network Equipment': { background: '#FDEDEC', color: '#922B21' },
};

const defaultStyle: CategoryStyle = {
  background: '#F8F9F9',
  color: '#2C3E50',
};

interface CategoryTagProps {
  category: string;
}

const AssetCategory: React.FC<CategoryTagProps> = ({ category }) => {
  const capitalize = Capitalize(category);

  const style =
    knownCategoryStyles[capitalize as KnownCategory] ?? defaultStyle;

  return (
    <span
      style={{
        padding: '2px 8px',
        borderRadius: '10px',
        fontSize: '0.75rem', // smaller text
        fontWeight: 500,
        display: 'inline-block',
        backgroundColor: style.background,
        color: style.color,
        lineHeight: 1.5,
      }}
    >
      {capitalize}
    </span>
  );
};

export default AssetCategory;
